import React from 'react'
import Work from "../../assets/images/workspace.png"
import { Link } from 'react-router-dom'
import logo from "../../assets/logo/logo.jpg"

const WorkSpace = () => {
    return (
        <div className='mt-0 '>
            <div className="bg-mblue py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10">
                    <div className="max-w-5xl mx-auto text-center">
                        <h2 className="text-3xl font-bold font-mfont text-mcolor sm:text-4xl">
                            Work Space
                        </h2>
                        <p className="mt-10 mb-10 text-mcolor 
                            lg:mb-8 font-semibold font-mfont md:text-lg lg:text-2xl dark:text-gray-400">
                            The workplace culture and environment has a significant impact on employees'
                            morale, productivity and job satisfaction. </p>
                    </div>
                </div>
                <div className="mt-0 ">
                    <div className="relative">
                        <div className="absolute inset-0 h-1/2 bg-mblue"></div>
                        <div className="relative max-w-7xl mx-auto  px-4 sm:px-6 lg:px-8">
                            <div className="max-w-7xl mx-auto">
                                <dl className="rounded-lg bg-white border shadow-lg m-3 sm:grid sm:grid-cols-3">
                                    <div className="flex  border-b justify-center border-gray-100 p-10 items-center sm:border-0 sm:border-r">
                                        <img src={logo} className="h-20 mr-3" alt="logo" />
                                        <h2 className='text-md font-bold font-mfont'>Making Minds Technologies<br />
                                            <span className='text-4xl font-bold font-mfont'>Workplace</span>
                                        </h2>
                                    </div>
                                    <div className="flex flex-col  justify-left border-gray-100 p-10 items-left ">
                                        <p className=" text-xl font-bold font-mfont text-mblack"> Office, files, meetings, and enterprise email all work together.</p><br />
                                        <Link to="/makingminds/workspace" className=" text-center  items-left
                            justify-left px-5 py-3 mr-1  relative text-xl flex hover:opacity-75  
                            focus:ring-gray-300 active:opacity-[0.85]
                            font-medium  text-white rounded-sm bg-mcolor hover:bg-mcolor
            focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900">
                                            Try now
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="30"
                                                height="30"
                                                viewBox="0 0 24 24"
                                                className=''
                                                fill="none"
                                            >
                                                <path
                                                    d="M10 7L15 12L10 17"
                                                    stroke="#fff"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </Link>
                                    </div>
                                    <div className="sm:flex flex-col justify-center hidden p-10 items-center">
                                        <img src={Work} alt='learning' />
                                    </div>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WorkSpace